// extracted by mini-css-extract-plugin
export default {"mainNavbar":"Navbar_mainNavbar__uHzns"};